<template>
    <section container>
        <section content padding>
            <div support class="d-flex">
                <div left class="d-block">
                    <div class="d-block" style="z-index: 99;">
                        <Select size="large" v-model="pid" v-if="product.length > 0" @on-select="selectProduct">
                            <Option :value="item.id" v-for="(item, index) in product" :key="index">{{ item.name }}</Option>
                        </Select>
                    </div>
                    <br/>
                    <Menu width="auto" :active-name="0" v-if="support.length > 0" style="z-index: 0;">
                        <MenuItem :name="index" v-for="(item, index) in support" :key="index" @click.native="onSupport(item, index)">{{ item.title }}</MenuItem>
                    </Menu>
                </div>
                <div right class="d-flex-item">
                    <div data-box="article" class="d-block" v-html="articleData" v-if="articleData"/>
                    <div class="d-flex flex-column justify-center" style="padding: 128px 64px;" v-else>
                        <Icon type="ios-warning" size="80" color="#ddd"/>
                        <br/>
                        <h1 class="c-gray">暂无支持文档</h1>
                    </div>
                </div>
            </div>
        </section>
    </section>
</template>

<script type="text/javascript">
    export default {
        data() {
            return {
                pid: '',
                product: [],
                support: [],
                articleData: null,
            }
        },
        async mounted() {
            this.product = [] = await this.$common.product();
            console.log('this.product---------->', this.product);
            if (this.$route.query.id){
                this.pid = this.$route.query.id;
            } else {
                this.pid = this.product[0].id;
            }
            await this.getSupport();
        },
        methods: {
            async selectProduct(data){
                console.log('this.selectProduct---------->', data);
                this.pid = data.value;
                this.articleData = null;
                await this.getSupport();
            },
            async getSupport(){
                let res = await this.$api.getHttp('/product/support?id=' + this.pid + '&lang=' + this.$common.config.lang);
                this.support = [] = res.data.data;
                if (this.support.length > 0){
                    this.articleData = {} = this.support[0].content;
                }
                console.log('this.getSupport---------->', this.support);
            },
            onSupport(data, i){
                console.log('this.onSupport---------->', data, i);
                this.articleData = {} = data.content;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/support/index.vue